  // Check if the cookie banner was acknowledged
  function checkCookieBanner() {
    if (localStorage.getItem('cookieBannerAcknowledged') !== 'TRUE') {
      showCookieBanner();
    }
  }

  // Show cookie banner
  function showCookieBanner() {
    const cookieBanner = document.querySelector('.cookies');
    if (cookieBanner) {
      cookieBanner.style.display = 'flex';
      setTimeout(() => {
        localStorage.setItem('cookieBannerAcknowledged', 'TRUE');
        updateConsent();
        loadGtagScript();
      }, 200);
    }
  }

  // Update consent with gtag
  function updateConsent() {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('consent', 'update', {
      ad_user_data: 'granted',
      ad_personalization: 'granted',
      ad_storage: 'granted',
      analytics_storage: 'granted'
    });
  }

  // Load the GTM script
  function loadGtagScript() {
    var gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-1031581247';
    var firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(gtagScript, firstScript);
  }

  // Close cookie banner
  function closeCookieBanner() {
    const closeButton = document.querySelector('.close');
    const cookieBanner = document.querySelector('.cookies');

    if (closeButton) {
      closeButton.addEventListener('click', function() {
        if (cookieBanner) {
          cookieBanner.style.display = 'none';
        }
      });
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    checkCookieBanner();
    closeCookieBanner();
  });